import { postApi } from "./api_instance";

export const uploadProject = async (info, dispatch) => {
  try {
    const { data } = await postApi({
      apiUrl: "/projects/api/create",
      sendToken: true,
      dispatch,
      data: info,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
